export const biddingLocale = {
    'zhCN': {
        bidding: {
            projectNO: '项目编号',
            addModelTitle: '新增招标项目管理',
            editModelTitle: '编辑招标项目管理',
            detailModelTitle: '招标项目详细',
            projectName: '项目名称',
            province: '省份',
            city: '城市',
            county: '区县',
            projectYear: '项目年份',
            projectStatus: '项目状态',
            biddingType: '招标类型',
            biddingTypeName: '招标类型名称',
            biddingTypeDescribe: '招标类型描述',
            principal: '负责人',
            startTime: '项目执行日期',
            endTime: '项目终止日期',
            startUpTime: '启动日期',
            comeOutTime: '公布结果日期',
            remark: '备注',
            purchaser: '采购主体',
            projectCycle: '项目执行周期',
            startProjectCycle: '项目执行周期起',
            endProjectCycle: '项目执行周期止',
            type: '类型',
            priceType: '价格类别',
            time: '时间',
            status: '状态',
            qualityLevel: '质量层次',
            biddingStatus: '招标状态',
            product: '产品',
            biddingNetPrice: '执行中标/挂网价',
            actualPrice: '实际采购价',
            purchaseStartTime: '采购周期起',
            purchaseEndTime: '采购周期终',
            distributor: '投标主体',
            creator: '创建人',
            finalEditor: '修改人',
            createTime: '创建时间',
            finalEditTime: '修改时间',
            validLocationRequired: '省份/军区未选择',
            validCityRequired: '省份/军区/城市未选择',
            validCountyRequired: '省份/军区/城市/区县未选择',
            validBiddingTypeRequired: '招标类型未选择',
            validProjectStatusRequired: '项目状态未选择',
            validProjectNameRequired: '项目名称不能为空',
            validProjectNameLength: '项目名称过长',
            validPurchaserRequired: '采购主体不能为空',
            validPurchaserLength: '采购主体过长',
            validProjectYearLength: '项目年份未选择',
            validProjectCycleRequired: '项目执行周期未选择',
            validProjectScopeRequired: '项目执行范围未选择',
            validPrincipalRequired: '负责人未选择',
            validStartUpTimeRequired: '启动时间未选择',
            whetherDeleteBidding: '是否删除该招标',
            whetherDeleteProjectState: '是否删除该项目状态',
            whetherDeleteBiddingState: '是否删除该招标状态',
            alreadyChoosePrincipal: '该负责人已选择',
            uploadFormatError: '上传文件格式不正确，格式支持pdf,jpg,jpeg,png,tif,doc,xls,zip,7z,xlsx,docx,msg',
            uploadFormatTifError: '上传文件格式不正确，格式支持pdf,jpg,jpeg,png,doc,xls,zip,7z,xlsx,docx,msg',
            stepUploadFormatError: '文件格式不正确，格式支持pdf,jpg,jpeg,png,doc,xls,zip,7z,xlsx,docx,msg',
            validStartTimeRequired: '项目执行周期起未选择',
            validEndTimeRequired: '项目执行周期止未选择',
            projectCycleErrorMessage: '项目周期开始时间不能大于项目周期终止时间',
            validInputComplete: '请确认完整填写全部必填信息后再保存',
            defaultBiddingState: '默认招标状态',
            projectStateManagement: '项目状态管理',
            projectStateSort: '项目状态排序',
            projectStateName: '项目状态名称',
            projectStateCode: '项目状态Code',
            projectStateDescription: '项目状态描述',
            projectStateNameIsNotNull: '项目状态名不能为空',
            projectStateCodeIsNotNull: '项目状态Code不能为空',
            projectStateNameOverLength: '项目状态名长度超过限制',
            projectStateCodeOverLength: 'Code长度超过限制',
            projectStateDescriptionOverLength: '项目状态描述长度超过限制',
            biddingStateName: '招标状态名称',
            biddingStateDescription: '招标状态描述',
            biddingStateCode: '招标状态Code',
            biddingStateNameIsNotNull: '招标状态名不能为空',
            biddingStateCodeIsNotNull: '招标状态Code不能为空',
            biddingStateNameIsNotRepeat: '招标状态名不能重复',
            biddingStateCodeIsNotRepeat: '招标状态Code不能重复',
            biddingStateCodeOverlength: '招标状态Code长度超过限制',
            biddingStateNameOverlength: '招标状态名长度超过限制',
            biddingStateDescriptionOverlength: '招标状态描述长度超过限制',
            validNoteInputTooLong: '输入字段过长',
            validIsCompensation: '是否涉及补偿必填',
            biddingProject: '招标项目',
            tenderVariety: '招标品种',
            tenderAttachment: '招标附件',
            biddingProjectScope: '项目执行范围',
            purchaseName: '采购主体名称',
            purchaseType: '类型',
            purchasePHCode: 'PHCode',
            selectPurchase: '选择采购主体',
            priceTime: '价格日期',
            price: '价格',
            brandName: '品牌',
            productLineName: '产品线',
            cityName: '城市',
            integrityOfBidding: '为了招标项目的完整性，请进行补充流程步骤附件',
            integrityOfBiddingComment: '  (自2021年8月9日起，所有招标附件上传至“自行投标”栏，“委托投标”上传栏停用)',
            PleaseSaveItFirst: '有尚未保存的数据，请先保存',
            independentBiddingStepCount: '自行投标完成步骤',
            entrustedBiddingStepCount: '委托投标完成步骤',
            addSecondBargaining: '新增二次议价项目',
            changeBiddingProject: '变更状态申请',
            whetherSubmitChangeBiddingProject: '提交后不可撤回，是否确认提交？',
            changeBiddingProjectTips: '提示',
            secondBargainingHasNotFinishedForm: '该项目存在未完成的审批单据',
            secondBargainingLocked: '该项目正在锁定状态',
            isSecondBargaining: '是否二次议价项目',
            changeRequest: '变更状态',
            addBiddingConfirm: '二次议价项目申请确认成功',
            addBiddingReject: '二次议价项目申请拒绝成功',
            changeBiddingConfirm: '二次议价变更项目状态确认成功',
            changeBiddingReject: '二次议价变更项目状态拒绝成功',
            changeBiddingApproval: '二次议价变更项目状态审批成功',
            projectStartLessThanPriceStartTimeErrorMessage: '项目周期开始时间必须小于采购价格周期起',
            projectEndGreaterThanPriceStartTimeErrorMessage: '项目周期截止时间必须大于采购价格周期起',
            projectStartLessThanPriceEndTimeErrorMessage: '项目周期开始时间必须小于采购价格周期终',
            projectEndGreaterThanPriceEndTimeErrorMessage: '项目周期截止时间必须大于采购价格周期终',
            selectProvince: '请先选择省份',
            whetherClose: '关闭页面，所填数据会清空，是否继续？',
            isDeleteQuotationAnalysisAttachment: '当前价格涉及报价分析表附件，是否确认删除？',
            purchaserPHCode: 'PHCode',
            validProjectScopeAndLocation: '项目执行范围为区县标时必须选择区县',
            PurchaserFormer: '采购主体曾用名',
            submitMessage: '提交后申请单信息不可修改，确定要提交此申请？',
            deleteMaterialGroupMessage: '是否确认删除，确认后删除此分型及分型下的所有附件和价格信息。',
            selectEndOfProjectMessage: '当前项目未结束不能选择项目结束',
            startUpTimeLessthanStartTimeMessage: '启动日期不能大于项目执行周期起',
            fileNameAlreadyExist: '文件名称在当前节点中已经存在',
            fileNameRepeat: '文件名称重复',
            fileSizeTooLarge: '超出上传文件最大限制，文件不能超过20M。',
            atLeastOne: '请至少上传一个文件',
            startRealDate: '开始月份',
            endRealDate: '结束月份'
        },
        biddingDetail: {
            addTitle: '新增招标详细信息',
            editTitle: '编辑招标详细信息',
            referred: '产品',
            materialGroup: '分型',
            category: '入围目录',
            isCompensation: '是否涉及补偿',
            distributor: '投标主体',
            packing: '单位',
            projectStatus: '招标状态',
            biddingStatus: '招标状态',
            biddingNetPrice: '执行中标/挂网价',
            actualPrice: '实际采购价格',
            startTime: '采购周期起',
            endTime: '采购周期终',
            qualityLevel: '质量层次',
            remark: '备注',
            productRemark: '产品备注',
            productMaterialGroup: '产品/分型',
            productMaterialGroupEmptyMessage: '产品/分型不能为空。',
            distributorEmptyMessage: '投标主体不能为空。',
            startTimeEmptyMessage: '请填写采购周期起。',
            biddingNetPriceEmptyMessage: '执行中标/挂网价格式不正确,请填写[挂网][未中标][未投标]或价格。',
            actualPriceEmptyMessage: '实际采购价格格式不正确。',
            priceEmptyMessge: '请填写价格信息。',
            cycledateerror: '采购周期终必须大于采购周期起。',
            lastStartTimeError: '前一条的采购周期起必须填写。',
            hasPriceNotSave: '价格信息已填写，但未进行添加，是否继续？',
            productInfo: '产品信息',
            priceInfo: '价格信息',
            purchaseCycleNotNull: '上一步采购周期起不可以为空。',
            currentCycleNotNull: '当前采购周期起不可以为空。',
            mastbeSave: '上一步数据请先修改（保存）。',
            morethan: '当前得采购周期起 不能早于 上一步采购周期起。',
            endtoend: '采购周期必须首尾相接。',
            laterthan: '采购周期起 不能晚于 采购周期终。',
            purchaseCycleEndNotNull: '上一步采购周期终不能为空。',
            lastAndThisNotNull: '上一步采购周期终和当前采购周期起不能为空。',
            lastAndThisLaterThan: '上一步采购周期终必须早于当前采购周期终。',
            hasDataNotAdd: '没有编辑任何数据，不可以保存',
            priceRemark: '价格备注',
            priceContinuation: '价格延续日期',
            IsContinue: '是否延续价格',
            uploadFileName: '文件名称',
            uploadTime: '上传时间',
            uploadOperator: '上传人',
            haveLeastOneAttachment: '至少要有一个附件',
            startToend: '起始采购周期起不可为空',
            noDataAvailable: '当前没有可用的步骤，请联系管理员处理',
            selfBiddingButName: '自行投标选中文件下载',
            entrustedBiddingButName: '委托投标选中文件下载',
            productButName: '产品变更价格选中文件下载',
            continuationPrice: '所输入执行中标/挂网价与上一执行中标/挂网价一致，未选择延续，是否提交？',
            deleteNewPrice: '所输入执行中标/挂网价与下一执行中标/挂网价一致，请重新输入执行中标/挂网价，或删除之后的价格重新添加。',
            maintenancePrice: '请为产品分别维护价格信息！',
            biddingLocked: '停用',
            biddingNormal: '启用',
            supportedFormats: '支持格式：',
            selectedPerson: '已选负责人',
            batchDownloadBiddingStepFile: '请选择需要下载的文件夹',
            quotationAnalysisReport: '报价分析表',
            currentBiddingPrice: '现行中标价/采购价',
            ceillingPrice: '限价要求',
            nationalMinimumProvionalBiddingPrice: '全国最低省级中标价',
            nationalMinimumActualPrice: '全国最低实际交易价',
            fallVSCBP: '降幅（VS现行中标价）',
            fallVSNMPBP: '降幅（VS全国最低省级中标价）',
            fallVSNMAP: '降幅（VS全国最低实际交易价）',
            targetHospitalMAT: '医疗机构SP（目标医院）',
            notTargetHospitalMAT: '医疗机构SP（非目标医院）',
            targetHospitalLocationMAT: '省（市）SP',
            salesProportionOfTargetHospitals: '医疗机构（目标医院）在*省（市）销售占比',
            salesProportionOfNotTargetHospitals: '医疗机构（非目标医院）在*省（市）销售占比',
            buIsAgreeNewPrice: 'BU是否同意以该新价格进行招标补偿',
            offerProposal: '报价建议',
            uploadFormatError: '文件类型错误，仅支持xlsx类型文件。',
            uploadError: '处理上传数据时出错，请联系管理员。',
            uploadMaxSizeError: '超出上传文件最大限制，文件不能超过20M。',
            quotationAnalysisReportTemplate: '报价分析表模板',
            addQuotationAnalysis: '新增报价分析',
            salesDateRange: '参考销量时间',
            existsDuplicateProvince: '已存在相同的省份或城市。',
            validProvinceAndCity: '请选择省份/城市。',
            validSalesMonthRange: '参考销售起始月份不可以早于截止月份。',
            validSalesMonth: '请选择参考销售月份。',
            validQuotationDetail: '请添加报价分析表的明细信息。',
            editQuotationAnalysis: '编辑报价分析',
            validCurrentBiddingPriceRequired: '现行中标价/采购价不能为空',
            validCeillingPriceRequired: '限价要求不能为空',
            validNationalMinimumProvionalBiddingPriceRequired: '全国最低省级中标价不能为空',
            validNationalMinimumActualPriceRequired: '全国最低实际交易价不能为空',
            validTargetHospitalMATRequired: '医疗机构SP（目标医院）不能为空',
            validNotTargetHospitalMATRequired: '医疗机构SP（非目标医院）不能为空',
            validTargetHospitalLocationMATRequired: '省（市）SP（目标医院）不能为空',
            validSalesProportionOfTargetHospitalsRequired: '医疗机构（目标医院）在*省（市）销售占比不能为空',
            validSalesProportionOfNotTargetHospitalsRequired: '医疗机构（目标医院）在*省（市）销售占比不能为空',

            validCurrentBiddingPriceFormatError: '现行中标价/采购价格式错误',
            validCeillingPriceFormatError: '限价要求格式错误',
            validNationalMinimumProvionalBiddingPriceFormatError: '全国最低省级中标价格式错误',
            validNationalMinimumActualPriceFormatError: '全国最低实际交易价格式错误',
            validTargetHospitalMATFormatError: '医疗机构SP（目标医院）格式错误',
            validNotTargetHospitalMATFormatError: '医疗机构SP（非目标医院）格式错误',
            validTargetHospitalLocationMATFormatError: '省（市）SP（目标医院）格式错误',
            validSalesProportionOfTargetHospitalsFormatError: '医疗机构（目标医院）在*省（市）销售占比格式错误',
            validSalesProportionOfNotTargetHospitalsFormatError: '医疗机构（目标医院）在*省（市）销售占比格式错误',
            validCurrentBiddingPriceNotZero: '现行中标价/采购价不能为0',
            validNationalMinimumProvionalBiddingPriceNotZero: '全国最低省级中标价不能为0',
            validNationalMinimumActualPriceNotZero: '全国最低实际交易价不能为0',
            validNotTargetHospitalMATNotZero: '医疗机构SP（非目标医院）不能为0',
            validTargetHospitalLocationMATNotZero: '省（市）SP（目标医院）不能为0',
            validOfferProposalMaxLength: '报价建议超长',
            confirmToSave: '保存后会覆盖现有报价分析表的明细数据，是否确认保存？',
            materialGroupExist: '分型已经在报表中存在，不能重复添加',
            existsDuplicateMaterialGroup: '已存在相同的分型。',
            validAttachmentNameError: 'xlsx或xls类型的附件名称不能为"报价分析表V"',
            validBiddingStartTimeisNullOfBiddingStatus: '招标状态为“停产、停止采购、项目结束”时，采购周期起字段为必填',
            validBiddingEndTimeisNullOfBiddingStatus: '招标状态为“停产、停止采购、项目结束”时，采购周期终字段为必填',
            notUploadQuotationAnalysisReport: '必须上传报价分析表',
            biddingNetPriceValidate: '执行中标/挂网价最多九位整数、三位小数或输入未中标、未投标、挂网',
            biddingActualPriceValidate: '实际采购价最多九位整数、三位小数',
            checkBiddingPriceAlreadyAdd: '价格数据未点击新增会丢失，是否确认',
            winBidStatusBiddingNetPriceRequired: '招标状态为“已中标”时，执行中标/挂网价为必填项。',
            purchasingtatusStartTimeRequired: '招标状态为“采购中”时，采购周期起为必填字段',
            purchasingtatusBiddingNetPriceRequired: '招标状态为“采购中”时，执行中标/挂网价为必填字段',
            validBiddingEndTimeNotNullStatus: '采购周期终仅适用于停止采购、停产、项目结束状态，请修改招标状态',
            biddingPriceStatus: '招标状态',
            referenceBiddingNetPriceNull: '参照价格没有执行中标/挂网价，无法延续',
            whetherDeleteBiddingPriceAttachment: '是否删除该附件',
            validLocationMATOfTargetHospitalNumberError: '省（市）SP不能小于*医疗机构SP（目标医院）与*非医疗机构SP（目标医院）的和'
        },
        biddingPriceConflict: {
            conflictType: '冲突类型',
            recalculation: '确认是否重新计算报表？',
            recalculationCompleted: '重新计算完成。'
        },
        biddingSteps: {
            using: '使用中',
            terminated: '已停用',
            chineseStepName: '中文步骤名称',
            englishStepName: '英文步骤名称',
            inputChineseStepName: '请输入中文步骤名称',
            inputEnglishStepName: '请输入英文步骤名称',
            entrustedBidding: '委托投标',
            selfBidding: '自行投标',
            newAdditionsMayNotBeDiscontinued: '新增项不可以停用',
            chineseStepNameIsRequired: '中文步骤名称为必填项',
            englishStepNameIsRequired: '英文步骤名称为必填项',
            chineseStepNameNoRepetition: '中文步骤名称不能重复',
            englishStepNameNoRepetition: '英文步骤名称不能重复',
            hasStep: '有此步骤',
            notHasStep: '无此步骤'
        },
        biddingType: {
            biddingTypeNameNull: '招标类型名称不能为空',
            biddingTypeNameLength: '招标类型名称长度超过限制',
            biddingTypeDescriptionNull: '招标类型描述不能为空',
            biddingTypeDescriptionLength: '招标类型描述长度超过限制',
            biddingTypeDefaultScopeIDNull: '项目执行范围不能为空'
        },
        biddingRequest: {
            newRequestlTitle: '新增招标二次议价项目申请',
            validLocationRequired: '省份未选择',
            validCityRequired: '省份/城市未选择',
            validCountyRequired: '省份/城市/区县未选择',
            approvalBiddingTitle: '二次议价项目申请',
            biddingRequestInfo: '招标项目',
            priceAttachment: '价格附件'
        },
        biddingMonthRealPrice: {
            disShowStopMaterialGroup: '不显示停用分型',
            showStopMaterialGroup: '显示停用分型'
        }
    },
    'enUS': {
        bidding: {
            projectNO: 'Bidding Project NO',
            addModelTitle: 'Add Bidding Project',
            editModelTitle: 'Edit  Bidding Project',
            detailModelTitle: 'Bidding Project Detail',
            projectName: 'Project Name',
            province: 'Province',
            city: 'City',
            county: 'County',
            projectYear: 'Project Year',
            projectStatus: 'Project Status',
            biddingType: 'Bidding Type',
            biddingTypeName: 'Name of tender type',
            biddingTypeDescribe: 'Description of Bidding Types',
            principal: 'Principal',
            startTime: 'Start Time',
            endTime: 'End Time',
            startUpTime: 'Start Up Time',
            comeOutTime: 'Come Out Time',
            remark: 'Remark',
            purchaser: 'Purchaser',
            projectCycle: 'Project Cycle',
            startProjectCycle: 'Starting of project execution cycle',
            endProjectCycle: 'End of project execution cycle',
            type: 'Type',
            priceType: 'Price Type',
            time: 'Time',
            status: 'Status',
            creator: 'Creator',
            finalEditor: 'Final Editor',
            createTime: 'Create Time',
            finalEditTime: 'Final EditTime',
            qualityLevel: 'Quality Level',
            biddingStatus: 'Bidding Status',
            product: 'Product',
            biddingNetPrice: 'Bidding Net Price',
            actualPrice: 'Actual Price',
            purchaseStartTime: 'Purchase Start Time',
            purchaseEndTime: 'Purchase End Time',
            distributor: 'Distributor',
            validLocationRequired: 'Required',
            validCityRequired: 'Required',
            validCountyRequired: 'Required',
            validBiddingTypeRequired: 'Required',
            validProjectStatusRequired: 'Required',
            validProjectScopeRequired: 'Required',
            validProjectNameRequired: 'Required',
            validProjectNameLength: 'Project Name is too long.',
            validPurchaserRequired: 'Required',
            validPurchaserLength: 'Purchaser is too long.',
            validProjectYearLength: 'Required',
            validProjectCycleRequired: 'Required',
            validPrincipalRequired: 'Required',
            validStartUpTimeRequired: 'Required',
            whetherDeleteBidding: 'Are you sure you want to delete it?',
            whetherDeleteProjectState: 'Are you sure you want to delete it?',
            whetherDeleteBiddingState: 'Are you sure you want to delete it?',
            alreadyChoosePrincipal: 'The person in charge has been selected.',
            uploadFormatError: 'Upload file format incorrect, format support pdf, jpg, jpeg, png, tif, doc, xls, zip, 7z, xlsx,docx',
            uploadFormatTifError: 'Upload file format incorrect, format support pdf, jpg, jpeg, png, doc, xls, zip, 7z, xlsx,docx',
            stepUploadFormatError: 'Upload file format incorrect, format support pdf,jpg,jpeg,png,doc,xls,zip,7z,xlsx,docx,msg',
            validStartTimeRequired: 'Project execution cycle not selected',
            validEndTimeRequired: 'Project execution cycle not selected',
            projectCycleErrorMessage: 'Project cycle start time cannot be greater than project cycle start time',
            validInputComplete: 'Please confirm that you have completed all required.',
            defaultBiddingState: 'Default Bidding State',
            projectStateManagement: 'Project State Management',
            projectStateDescription: 'Project State Description',
            projectStateSort: 'Project State Sort',
            projectStateName: 'Project State Name',
            projectStateCode: 'Project State Code',
            projectStateNameIsNotNull: 'Required',
            projectStateCodeIsNotNull: 'Required',
            projectStateNameOverLength: 'Project State Name is too long',
            projectStateCodeOverLength: 'Code is too long',
            projectStateDescriptionOverLength: 'Project State Description is too long',
            biddingStateNameIsNotNull: 'Required',
            biddingStateCodeIsNotNull: 'Required',
            biddingStateNameIsNotRepeat: 'Bidding State Name can not be repeated.',
            biddingStateCodeIsNotRepeat: 'Bidding State Code can not be repeated.',
            biddingStateCodeOverlength: 'Bidding State Code is too long.',
            biddingStateNameOverlength: 'Bidding State Name is too long.',
            biddingStateDescriptionOverlength: 'Bidding State Description is too long.',
            biddingStateName: 'Bidding State Name',
            biddingStateDescription: 'Bidding State Description',
            biddingStateCode: 'Bidding State Code',
            validNoteInputTooLong: 'Input field is too long.',
            validIsCompensation: 'Whether compensation is required',
            biddingProject: 'Bidding project',
            tenderVariety: 'Tender variety',
            tenderAttachment: 'Tender attachment',
            biddingProjectScope: 'Project Scope',
            purchaseName: 'Purchase Name',
            purchaseType: 'Purchase Type',
            purchasePHCode: 'PHCode',
            selectPurchase: 'Choose Purchase',
            priceTime: 'Price Date',
            price: 'Price',
            brandName: 'Brand',
            productLineName: 'Product Line',
            cityName: 'City Name',
            integrityOfBidding: 'In order to complete the bidding project, please make supplementary process steps annex.',
            PleaseSaveItFirst: 'There is data that has not yet been saved. Please save it first.',
            independentBiddingStepCount: 'Independent BiddingStep Count',
            entrustedBiddingStepCount: 'Entrusted BiddingStep Count',
            addSecondBargaining: 'Add Second Bargaining Bidding',
            changeBiddingProject: 'Change State Request',
            whetherSubmitChangeBiddingProject: 'It cannot be withdrawn after submission. Do you want to confirm the submission? ',
            changeBiddingProjectTips: 'Tips',
            secondBargainingHasNotFinishedForm: 'There are unfinished approval documents for this project.',
            secondBargainingLocked: 'The project is locked.',
            isSecondBargaining: 'is Second Bargaining',
            changeRequest: 'Status change',
            projectStartLessThanPriceStartTimeErrorMessage: 'Project cycle start time must be less than purchase price cycle start time ',
            projectEndGreaterThanPriceStartTimeErrorMessage: 'Project cycle end time must be greater than purchase price cycle start time ',
            projectStartLessThanPriceEndTimeErrorMessage: 'Project cycle start time must be less than purchase price cycle end time ',
            projectEndGreaterThanPriceEndTimeErrorMessage: 'Deadline of project cycle must be greater than the end of purchase price cycle ',
            addBiddingConfirm: 'Confirm success',
            addBiddingReject: 'Reject success',
            addBiddingApproval: 'Approval success',
            changeBiddingConfirm: 'Confirm success',
            changeBiddingReject: 'Reject success',
            changeBiddingApproval: 'Approval success',
            selectProvince: 'Please select province',
            projectEndTimeErrorMessage: 'Project cycle start time must be less than purchase price cycle end time',
            whetherClose: 'Close the page and the data will be cleared. Do you want to continue? ',
            isDeleteQuotationAnalysisAttachment: 'The current price involves the attachment of quotation analysis report. Are you sure to delete it？',
            purchaserPHCode: 'PHCode',
            validProjectScopeAndLocation: 'The scope is county, county must be selected',
            PurchaserFormer: 'Purchaser former name',
            submitMessage: 'The application form information cannot be modified after submission. Are you sure you want to submit this application?',
            deleteMaterialGroupMessage: 'Confirm to delete. After confirmation, delete all attachments and price information under this sub type and sub type.',
            selectEndOfProjectMessage: 'The bidding project not completed,can not be selet End of project',
            startUpTimeLessthanStartTimeMessage: 'Start date must be less than the start of project execution cycle ',
            fileNameAlreadyExist: ',Duplicate file name already exists in the current node',
            fileNameRepeat: ',Duplicate file name',
            fileSizeTooLarge: ',Maximum character limit exceeded',
            atLeastOne: 'Upload at least one attachment',
            startRealDate: 'Start month',
            endRealDate: 'End month'
        },
        biddingDetail: {
            addTitle: 'Add Bidding Detail',
            editTitle: 'Edit Bidding Detail',
            referred: 'Referred',
            materialGroup: 'Material Group',
            category: 'Category',
            isCompensation: 'Whether compensation is involved',
            distributor: 'Distributor',
            packing: 'Packing',
            projectStatus: 'BiddingStatus',
            biddingStatus: 'BiddingStatus',
            biddingNetPrice: 'BiddingNetPrice',
            actualPrice: 'ActualPrice',
            startTime: 'StartTime',
            endTime: 'EndTime',
            qualityLevel: 'QualityLevel',
            remark: 'Remark',
            productRemark: 'Product Remark',
            productMaterialGroup: 'Referred/Material Group',
            productMaterialGroupEmptyMessage: 'Product/Material Group can not be empty.',
            distributorEmptyMessage: 'Distributor can not be empty.',
            startTimeEmptyMessage: 'StartTime can not be empty.',
            biddingNetPriceEmptyMessage: 'BiddingNetPrice error,please Fill in [挂网][未中标][未投保] or price.',
            actualPriceEmptyMessage: 'ActualPrice error.',
            priceEmptyMessge: 'Price can not be empty.',
            currentCycleNotNull: 'The current procurement cycle can not be empty.',
            cycledateerror: 'EndTime mast be later than startTime.',
            lastStartTimeError: 'The last StartTime can not be empty.',
            hasPriceNotSave: 'Price information has been filled in and not added. Do you want to continue?',
            productInfo: 'Product',
            priceInfo: 'Price',
            purchaseCycleNotNull: 'The last price detail StartTime mast be fill in.',
            mastbeSave: 'The last price detail need Update(Save).',
            morethan: 'This edit data StartTime can not be less than the last StartTime.',
            endtoend: 'The Procurement cycle mast be end to end.',
            laterthan: 'Procurement cycle should not start later than the end of the procurement cycle.',
            purchaseCycleEndNotNull: 'The last price detail EndTime mast be fill in.',
            lastAndThisNotNull: 'The last EndTime and this StartTime mast be fill in.',
            lastAndThisLaterThan: 'The end of the previous procurement cycle must be earlier than the end of the current procurement cycle.',
            hasDataNotAdd: 'No data can be saved without editing it',
            priceRemark: 'Price Remark',
            priceContinuation: 'Price Continuation',
            IsContinue: 'IsContinue',
            uploadFileName: 'File name:',
            uploadTime: 'Upload time',
            uploadOperator: 'Uploader',
            haveLeastOneAttachment: 'Have at least one attachment',
            startToend: 'Cannot be empty from the initial purchase cycle',
            noDataAvailable: 'There is currently no data available, please contact the administrator for processing.',
            selfBiddingButName: 'Self-bidding selected file download',
            entrustedBiddingButName: 'Entrusted bidding selected file download',
            productButName: 'Product change price selected file download',
            continuationPrice: 'The input bid/network price is the same as the previous bid/network price. It has not been selected to continue. Will it be submitted?',
            deleteNewPrice: 'The input execution bid/hang net price is the same as the next hang net price, please re-enter the execution bid/hang net price, or re-add the price after deletion.',
            maintenancePrice: 'Please maintain price information separately for the product!',
            biddingLocked: 'Disable',
            biddingNormal: 'Enable',
            supportedFormats: 'Supported formats:',
            selectedPerson: 'Selected person',
            batchDownloadBiddingStepFile: 'Please select a folder to download',
            quotationAnalysisReport: 'Quotation Analysis Report',
            currentBiddingPrice: 'Current Bidding Price',
            ceillingPrice: 'Ceilling Price',
            nationalMinimumProvionalBiddingPrice: 'National Minimum Provional Bidding Price',
            nationalMinimumActualPrice: 'National Minimum Actual Price',
            fallVSCBP: 'Fall VS CBP',
            fallVSNMPBP: 'Fall VS NMPBP）',
            fallVSNMAP: 'Fall VS NMAP',
            targetHospitalMAT: 'Target Hospital SP',
            notTargetHospitalMAT: 'Not Target Hospital SP',
            targetHospitalLocationMAT: 'Location SP',
            salesProportionOfTargetHospitals: 'Sales Proportion Of Target Hospitals',
            salesProportionOfNotTargetHospitals: 'Sales Proportion Of Not Target Hospitals',
            buIsAgreeNewPrice: 'BU Is Agree New Price Bidding',
            offerProposal: 'Offer Proposal',
            uploadFormatError: 'The file type is not supported, only file types in the format of xslt are supported.',
            uploadError: 'Error uploading, please contact administrator',
            uploadMaxSizeError: 'Exceeding file size limit, no more than 20M.',
            quotationAnalysisReportTemplate: 'Quotation Analysis Report Template',
            addQuotationAnalysis: 'Add Quotation Analysis',
            salesDateRange: 'Sales Date Range',
            editQuotationAnalysis: 'Edit quote analysis ',
            validCurrentBiddingPriceRequired: 'Required',
            validCeillingPriceRequired: 'Required',
            validNationalMinimumProvionalBiddingPriceRequired: 'Required',
            validNationalMinimumActualPriceRequired: 'Required',
            validTargetHospitalMATRequired: 'Required',
            validNotTargetHospitalMATRequired: 'Required',
            validTargetHospitalLocationMATRequired: 'Required',
            validSalesProportionOfTargetHospitalsRequired: 'Required',
            validSalesProportionOfNotTargetHospitalsRequired: 'Required',
            existsDuplicateProvince: 'Duplicate province or city already exists.',
            validProvinceAndCity: 'Please select a province / city.',
            validSalesMonth: 'Please select sales month range.',
            validSalesMonthRange: 'Sales start month cannot be earlier than the end month.',
            validQuotationDetail: 'Please add details of quotation analysis report.',
            validCurrentBiddingPriceFormatError: 'Format error',
            validCeillingPriceFormatError: 'Format error',
            validNationalMinimumProvionalBiddingPriceFormatError: 'Format error',
            validNationalMinimumActualPriceFormatError: 'Format error',
            validTargetHospitalMATFormatError: 'Format error',
            validNotTargetHospitalMATFormatError: 'Format error',
            validTargetHospitalLocationMATFormatError: 'Format error',
            validSalesProportionOfTargetHospitalsFormatError: 'Format error',
            validSalesProportionOfNotTargetHospitalsFormatError: 'Format error',
            validCurrentBiddingPriceNotZero: 'Cannot be zero',
            validNationalMinimumProvionalBiddingPriceNotZero: 'Cannot be zero',
            validNationalMinimumActualPriceNotZero: 'Cannot be zero',
            validNotTargetHospitalMATNotZero: 'Cannot be zero',
            validTargetHospitalLocationMATNotZero: 'Cannot be zero',
            validOfferProposalMaxLength: 'Offer Proposal length is too long ',
            confirmToSave: 'After saving, the details of the existing quotation analysis report will be overwritten. Are you sure you want to save?',
            materialGroupExist: 'MaterialGroup already exist',
            existsDuplicateMaterialGroup: 'The same typing already exists',
            addBiddingConfirm: 'Confirm success',
            addBiddingReject: 'Reject success',
            addBiddingApproval: 'Approval success',
            changeBiddingConfirm: 'Confirm success',
            changeBiddingReject: 'Reject success',
            changeBiddingApproval: 'Approval success',
            validAttachmentNameError: 'Attachment name of type xlsx or XLS cannot be "quotation analysis table V" ',
            validBiddingStartTimeisNullOfBiddingStatus: 'When the bidding status is "stop production, stop purchase, end project", the purchase cycle start field is required ',
            validBiddingEndTimeisNullOfBiddingStatus: 'When the bidding status is "stop production, stop purchase, end project", the purchase cycle end field is required ',
            notUploadQuotationAnalysisReport: 'Quotation analysis table must be uploaded.',
            biddingNetPriceValidate: 'Up to nine integers and three decimals in the execution of bid winning / online price ',
            biddingActualPriceValidate: 'The actual purchase price can be up to nine integers and three decimals ',
            checkBiddingPriceAlreadyAdd: 'Price data will be lost if you do not click Add. Confirm ',
            winBidStatusBiddingNetPriceRequired: 'When the bidding status is "bid winning", the execution of bid winning / online price is required. ',
            purchasingtatusStartTimeRequired: 'When the bidding status is "purchasing", the bid winning / online price and purchase cycle start are mandatory fields ',
            purchasingtatusBiddingNetPriceRequired: 'When the bidding status is "purchasing", the bid winning / online price is required',
            validBiddingEndTimeNotNullStatus: 'The end of the procurement cycle is only applicable to the stop of procurement, production suspension and project completion status. Please modify the bidding status',
            biddingPriceStatus: 'Bidding Status',
            referenceBiddingNetPriceNull: 'The reference price is not implemented and cannot be continued.',
            whetherDeleteBiddingPriceAttachment: 'Delete this attachment or not ',
            validLocationMATOfTargetHospitalNumberError: 'Provincial (city) SP cannot be less than the sum of * medical institution sp (target hospital) and * non-medical institution sp (target hospital)  '
        },
        biddingPriceConflict: {
            conflictType: 'Conflict Type',
            recalculation: 'Are you sure to recalculate the data?',
            recalculationCompleted: 'Recalculation completed.'
        },
        biddingSteps: {
            using: 'Using',
            terminated: 'Terminated',
            chineseStepName: 'Chinese step name',
            englishStepName: 'English step name',
            inputChineseStepName: 'Please enter the Chinese step name',
            inputEnglishStepName: 'Please enter the English step name',
            entrustedBidding: 'Entrusted bidding',
            selfBidding: 'Self-bidding',
            newAdditionsMayNotBeDiscontinued: 'New additions may not be discontinued',
            chineseStepNameIsRequired: 'Chinese step name is required',
            englishStepNameIsRequired: 'English step name is required',
            chineseStepNameNoRepetition: 'Chinese step names cannot be repeated without repeating them',
            englishStepNameNoRepetition: 'English step names cannot be repeated',
            hasStep: 'Has Step',
            notHasStep: 'Not Has Step'
        },
        biddingType: {
            biddingTypeNameNull: 'The name of bidding type cannot be empty',
            biddingTypeNameLength: 'The name length of bidding type exceeds the limit',
            biddingTypeDescriptionNull: 'The description of bidding type cannot be empty',
            biddingTypeDescriptionLength: 'Bidding Type Description Length Over Limitation',
            biddingTypeDefaultScopeIDNull: 'The scope of project implementation cannot be empty'
        },
        biddingRequest: {
            newRequestlTitle: 'New bidding rquest',
            validLocationRequired: 'Province can not be empty',
            validCityRequired: 'Province/city can not be empty',
            validCountyRequired: 'Province/city/county can not be empty',
            approvalBiddingTitle: 'Bidding Project Request',
            biddingRequestInfo: 'Base Info',
            priceAttachment: 'Price Attachments'
        },
        biddingMonthRealPrice: {
            disShowStopMaterialGroup: 'Disable parting is not displayed',
            showStopMaterialGroup: 'Display deactivated parting'
        }
    }
}
export default biddingLocale


// WEBPACK FOOTER //
// ./src/locale/modules/biddingLocale.js